import React, { useState } from "react";
import PerformanceAnalysisBreakdownBarWidget from "./PerformanceAnalysisBreakdownBarWidget";
import DefaultSelect from "components/DefaultSelect";
import { getUrl } from "@outplayed/riot-assets";
import { getRoleImg } from "lib/role_helper";
import PerformanceAnalysisTabs from "./PerformanceAnalysisTabs";
import { usePositionalBreakdown } from "../../../../hooks/performanceAnalysis/positionalBreakdown";

const PerformanceAnalysisPositionBreakdown = (props) => {
  const { positionBreakdown } = props;

  const changeFilter = (props) => {
    setChosenTier(props);
  };

  const switchTab = (index) => {
    setChosenRole(index);
  };

  const abbrRoleToFull = (role) => {
    const abbrMap = {
      adc: "BOT",
      supp: "SUPPORT",
      mid: "MID",
      top: "TOP",
      jungle: "JUNGLE",
    };

    if (abbrMap[role]) return abbrMap[role];
    return role;
  };

  if (!positionBreakdown) {
    return null;
  }

  const tabsData = positionBreakdown.map((role, index) => {
    return { label: abbrRoleToFull(role.roleName), callback: () => switchTab(index) };
  });

  const tiers = [
    { value: "bronze", label: "Bronze Players" },
    { value: "silver", label: "Silver Players" },
    { value: "gold", label: "Gold Players" },
    { value: "platinum", label: "Platinum Players" },
    { value: "diamond", label: "Diamond Players" },
  ];

  const [chosenTier, setChosenTier] = useState(tiers[0]);
  const [chosenRole, setChosenRole] = useState(0);
  let [averagePositionalBreakdown, setAveragePositionalBreakdown] = useState({ loading: true });
  usePositionalBreakdown(averagePositionalBreakdown, setAveragePositionalBreakdown, chosenTier.value);
  const stats = positionBreakdown.map((role) => {
    const tierStats =
      !averagePositionalBreakdown.loading && averagePositionalBreakdown && averagePositionalBreakdown[chosenTier.value]
        ? averagePositionalBreakdown[chosenTier.value][positionBreakdown[chosenRole].roleName]
        : null;
    return {
      playRate: (role.percentPlayed * 100).toFixed(1),
      stats:
        tierStats &&
        !averagePositionalBreakdown.loading &&
        averagePositionalBreakdown &&
        averagePositionalBreakdown[chosenTier.value]
          ? [
              {
                label: "KDA",
                first: role.kda.toFixed(1),
                second: tierStats.averageKda.toFixed(1),
                iconImg: "white_sword_icon.png",
                thousands: false,
              },
              {
                label: "AVG CS / MIN",
                first: role.avgCsPerMin.toFixed(1),
                second: tierStats.averageCsPerMinute.toFixed(1),
                iconImg: "white_cs_icon.png",
                thousands: false,
              },
              {
                label: "GOLD PER MIN",
                first: role.avgGoldPerMin.toFixed(0),
                second: tierStats.averageGoldPerMinute.toFixed(0),
                iconImg: "white_gold_icon.png",
                thousands: false,
              },
              {
                label: "AVG DMG MITIGATED",
                first: role.avgDmgMitigated.toFixed(0),
                second: tierStats.averageDmgMitigatedPerGame.toFixed(0),
                iconImg: "white_ward_icon.png",
                thousands: true,
              },
              {
                label: "AVG HEALING",
                first: role.avgDmgHealed.toFixed(0),
                second: tierStats.averageDmgHealedPerGame.toFixed(0),
                iconImg: "white_ward_icon.png",
                thousands: true,
              },
              {
                label: "DMG PER MIN",
                first: role.avgDmgPerMin.toFixed(0),
                second: tierStats.averageDmgDealtPerMinute.toFixed(0),
                iconImg: "white_sword_icon.png",
                thousands: true,
              },
            ]
          : [],
    };
  });

  const chosenRoleStats = stats[chosenRole];

  return (
    <div className="position-breakdown">
      <div className="header-text ">
        <div className="small-header">YOUR TOP 2 POSITIONS</div>
        <div className="large-header">POSITION BREAKDOWN</div>
        <div className="basic-text">
          See a breakdown of your top two most played positions and compare yourself with other players.
        </div>
      </div>
      <div className="role-tabs">
        <PerformanceAnalysisTabs tabsData={tabsData} loading={averagePositionalBreakdown.loading} />
      </div>
      <div className="positional-divider">
        <img src={getUrl(`lol/performance_analysis/images/positional_divider_left.svg`)} />
        <img className="roleIcon" src={getRoleImg(abbrRoleToFull(positionBreakdown[chosenRole].roleName).toLowerCase())} />
        <img src={getUrl(`lol/performance_analysis/images/positional_divider_right.svg`)} />
      </div>
      <div className="sub-header-text">
        <div className="large-header">{chosenRoleStats.playRate}%</div>
        <div className="small-header">{abbrRoleToFull(positionBreakdown[chosenRole].roleName)}</div>
        <div className="basic-text">PLAYRATE</div>
      </div>
      <div className="breakdown-filter">
        <DefaultSelect
          isDisabled={averagePositionalBreakdown.loading}
          width={"175px"}
          onChange={changeFilter}
          options={tiers}
          value={chosenTier.value}
        />
      </div>
      <div className="breakdown-legend">
        <div className="legend-holder">
          <div className="legend-container">
            <div className="breakdown-circle" />
            <div className="legend-text">Your Average</div>
          </div>
          <div className="legend-container">
            <div className="breakdown-circle blue" />
            <div className="legend-text">Tier Average</div>
          </div>
        </div>
        <div className="bar-explanation">(Higher results are better)</div>
      </div>
      {averagePositionalBreakdown.loading ? (
        <div className="position-breakdown-loader spinthatshit-loader"></div>
      ) : (
        <div className={"breakdown-loaded-content"}>
          <PerformanceAnalysisBreakdownBarWidget chosenTier={chosenTier} stats={chosenRoleStats.stats} />
        </div>
      )}
    </div>
  );
};

export default PerformanceAnalysisPositionBreakdown;
